"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withIndexRecipe = void 0;
function withIndexRecipe(map) {
    return function () {
        let idx = 0;
        return map.call(this, (t) => ({ idx: idx++, value: t }));
    };
}
exports.withIndexRecipe = withIndexRecipe;
